import RestService from '../services/rest';
import PreferencesData from '../../data/preferences';

async function authenticate(email, password, reCaptchaVerify) {
  return RestService.postRest('oauth/token', {
    username: email,
    password,
    reCaptchaVerify,
    grant_type: 'admin',
  });
}

async function refreshToken(token) {
  return RestService.postRest('oauth/token', {
    refresh_token: token,
    reCaptchaVerify: PreferencesData.noReCaptcha,
    grant_type: 'refresh_token',
  });
}

async function logout(aToken, rToken) {
  return RestService.postAuthenticated('oauth/revoke', {
    access_token: aToken,
    refresh_token: rToken,
  });
}

async function getUser() {
  return RestService.getAuthenticated('panel/users/details');
}

export default {
  authenticate,
  refreshToken,
  logout,
  getUser,
};
